module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow-em-big-d5e3481106008ea2232da4ae78a7cbdb.svg";